module.exports = (nameHolder, nameTag) => {
  let modelName;

  if(nameHolder.dataset.modelName)
    modelName = nameHolder.dataset.modelName;
  else if (nameHolder.hasAttribute('alt'))
    modelName = nameHolder.getAttribute('alt');
  else
    return;

  nameTag.innerHTML = modelName;
};


// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-modelname.js